import React from 'react';
import { ResponsivePie } from '@nivo/pie';

const PieChart = ({ data }) => (
  <div className="h-48">
    <ResponsivePie
      data={data}
      innerRadius={0.5}
      padAngle={1}
      cornerRadius={3}
      colors={{ datum: 'color' }}
      theme={{ fontFamily: 'Inter' } as any}
      enableRadialLabels={false}
      // radialLabel={(e) => e.id.toString()}
      // radialLabelsLinkDiagonalLength={10}
      // radialLabelsLinkHorizontalLength={5}
      // radialLabelsLinkColor="#fff"
      enableSlicesLabels={true}
      sliceLabel={(e) => e.value.toString() + '%'}
      slicesLabelsTextColor="#fff"
      animate={true}
      motionStiffness={90}
      motionDamping={15}
      margin={{ left: 0, right: 150, top: 0, bottom: 5 }}
      tooltip={(props) => (
        <div className="px-2 py-1 -m-3 text-xs text-white rounded bg-jcap-700">
          {props.id}
        </div>
      )}
      legends={[
        {
          anchor: 'right',
          direction: 'column',
          itemsSpacing: 12,
          itemWidth: 16,
          itemHeight: 16,
          itemTextColor: '#666',
          symbolSize: 18,
          symbolShape: 'circle',
          padding: { right: -40 },
          effects: [
            {
              on: 'hover',
              style: {
                itemTextColor: '#000',
              },
            },
          ],
        },
      ]}
    />
  </div>
);

export default PieChart;
